import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { WkAlfrescoApiService } from './wk-alfresco-api.service';

@Injectable({
  providedIn: 'root',
})
export class WkPasswordService {
  private readonly resetPasswordURL =
    'activiti-app/api/enterprise/wk/user/password/reset';
  private readonly createPasswordURL =
    'activiti-app/api/enterprise/wk/user/password';
  private readonly applicationTypeJson = ['application/json'];

  constructor(private readonly apiService: WkAlfrescoApiService) {}

  changePassword(data: {
    token: string;
    password: string;
  }): Observable<unknown> {
    return from(
      this.apiService.callContentClientCustomApi({
        path: this.createPasswordURL,
        httpMethod: 'PUT',
        bodyParam: data,
        contentTypes: this.applicationTypeJson,
        accepts: this.applicationTypeJson,
      })
    );
  }

  resetPassword(data: { email: string }): Observable<unknown> {
    return from(
      this.apiService.callContentClientCustomApi({
        path: this.resetPasswordURL,
        httpMethod: 'POST',
        bodyParam: data,
        contentTypes: this.applicationTypeJson,
        accepts: this.applicationTypeJson,
      })
    );
  }
}
